var _circle, _circle2, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.29,
    cx: 24,
    cy: 24.3145,
    r: 24,
    fill: "#1565C0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.58,
    cx: 24.0003,
    cy: 24.3147,
    r: 17.1429,
    fill: "#1565C0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 22,
    height: 22,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_1895",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_1895",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAAClUlEQVRoge2Zy27TQBSG/4mUbBregDdgQWkRhTcAIdG0qrqB96HAqhQWiGUv6/Y5uIkNhEI3TYB9UyQuUj4WnkruxInn4iQb/5KljHPOf84/9pwztqUaNWrUmCdMiDHQktSxx5Kkq5IWEnP4Jakv6b2kQ0mHxpi/iZyjANaBE6aPb8BalYk3gKczSNzFE6BRhYBnc0j+Alupya8XkP4GtoEVIPX+F7BguXaAPwXxOrHELUbv+T5wPTXpCTEXbYw8vgLNGLLNgpmvPHngvk26B9wDbhRciY0Y4gOHZLvq5G2cXi7GqT33wom9N85/0ipfdsb7Hsm07JU7ALrAuT269twmWS8pg5vwTQ+fkWTOnFlol9j79olLdd7eNj3gFLhrz11xfM5iBFzCBLvYPjGxzvvGr0JASp8YW+dnIgCPPkFknZ+6ACL6BAF1fhYCovoEnnXeV0DKZsm99K+MMR/LnIwxHyS9LuFKh8cV+OKY3Argvu34dkPjVyFg4JhM7BOOb9vxHcQKSN9vx8GNO6yKKAQ/nPG1AF/X9mdsEikC3jrjhwG+j5zxm4Q8iuGxBorK6KIH7xIVltEUAS2yjVke/UkibPLfHZ9j5tHIrM2aa2dndwe4Q1Zt2vb3y4KZHwIPYuMnC7B2KW8sHqfGr0JAg2xrHIIhsMWUt9OhDzQdso1ZGY6B1RKuSh5o3K3CiodPE9gA9oDPZN16AHwCdu1/pW8YyNZMHiNbDR8B+w7J82CSSJAt+Dx2Y0ii6nwq8OwTPkTBdT4VBPQJX8LSOl9B0lF9IiTAPN5MX2BsnwgREFPnU1HaJ2KE+Nb5VJT2iTxCPzE1Ja0qe4ZdVvaJKXUdnEvqSXon6UjSkTHmXyJnjRo1aswI/wHewskhvoy8HQAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgLogo);
export default __webpack_public_path__ + "static/media/ig-logo.e3fda70d16917bd2dec183f9f6c5af6e.svg";
export { ForwardRef as ReactComponent };